import { Decimal } from 'parrot-sui-sdk';

export const scaleDown = (value: Decimal | string | number, decimals: number) => {
  return new Decimal(value).div(10 ** decimals);
};

export const scaleUp = (value: Decimal | string | number, decimals: number) => {
  return new Decimal(value).mul(10 ** decimals);
};
